import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';
import { useLocalSearchParams } from 'expo-router';

import { Library } from '@/components/library';
import { LIBRARY_TAB_ROUTES, type LibraryTabKey } from '@/components/library.helpers';
import { Community } from '@/features/inquiry-library';

function toLibraryTab(value: string | undefined): LibraryTabKey | undefined {
  return LIBRARY_TAB_ROUTES.find((route) => route.key === value)?.key;
}

export default function CommunityTab() {
  const { tab } = useLocalSearchParams<{ tab?: string }>();

  if (isWeb) {
    return <Community />;
  }

  return <Library initialTab={toLibraryTab(tab)} />;
}
